<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import {
  getPath,
  add,
  getDetails,
  update,
  del,
  addRemark,
} from "@/api/auth/path";
import cTable from "@/base/common/index";
export default {
  name: "addPath",
  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        list: getPath,
        getDetails,
        del,
        add,
        update,
        addRemark,
        // afterHandleList() {
        //   this.getTable().setAllTreeExpand(true);
        // }
      },
      config: {
        height: 630,
        rowId: "id",
        treeConfig: {
          children: "children",
          // expandAll: true,
          accordion: true,
          reserve: true,
        },
      },
      modals: {
        add: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            title: this.$t("level"),
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              zh_title: [
                {
                  required: true,
                  trigger: "blur",
                },
                {
                  min: 3,
                  max: 155,
                  message: "Please enter 3 to 155 characters",
                  trigger: "blur",
                },
              ],
              path: [
                {
                  required: true,
                  trigger: "blur",
                },
              ],
              title: [
                {
                  required: true,
                  trigger: "blur",
                },
              ],
              sort: [
                {
                  required: true,
                  type: "number",
                  trigger: "blur",
                },
              ],
              status: [
                {
                  required: true,
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            { zh_title: 24 },
            { path: 24 },
            { title: 24 },
            { icon: 24 },
            { sort: 24 },
            { status: 24 },
          ],
          fields: [
            {
              name: () => this.$t("pathName"),
              key: "zh_title",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("pathName"),
            },
            {
              name: () => this.$t("pathUrl"),
              key: "path",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("pathUrl"),
            },
            {
              name: () => this.$t("zhTitle"),
              key: "title",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("zhTitle"),
            },
            {
              name: () => this.$t("pathIcon"),
              key: "icon",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("pathIcon"),
            },
            {
              name: () => this.$t("sort"),
              key: "sort",
              component: "InputNumber",
              bind: {
                min: 1,
                style: "width:100%",
                step: 1,
                max: 99,
              },
              default: 99,
            },
            {
              name: () => this.$t("enable") + " / " + this.$t("disable"),
              key: "status",
              component: "Radio",
              options: [
                { label: this.$t("enable"), value: "ENABLE" },
                { label: this.$t("disable"), value: "DISABLE" },
              ],
              bind: {
                border: true,
              },
              default: "ENABLE",
            },
          ],
        },
        addRemark: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("addRemark", row, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            rules: {
              remarks: [
                {
                  required: true,
                  message: "remarks be empty",
                  trigger: "bulr",
                },
              ],
            },
            formBind: {
              labelWidth: 100,
            },
            title: this.$t("order_desc"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          grid: [{ remarks: 24 }],
          fields: [
            {
              key: "remarks",
              name: () => this.$t("order_desc"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              },
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
          ],
        },
      },
      footer: { show: () => false },
      header: {
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            // bind: {
            //   type: "textarea",
            //   autosize: { minRows: 2, maxRows: 2 }
            // }
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("level"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning",
              },
              // 前端账号id判断
              show: ({ row }) =>
                [3265, 47,3372].indexOf(this.$store.getters.userId) != -1,
            },
          ],
          methods: {
            add() {
              this.getModal("add").open(
                { pid: 0, icon: "md-menu" },
                function () {
                  this.type = "add";
                }
              );
            },
          },
        },
      },
      fields: [
        {
          name: () => this.$t("pathName"),
          key: "zh_title",
          align: "left",
          minWidth: 150,
          columnBind: {
            "tree-node": true,
          },
        },
        {
          name: () => this.$t("zhTitle"),
          align: "left",
          key: "name",
          minWidth: 160,
        },
        {
          name: () => this.$t("pathUrl"),
          key: "path",
          align: "left",
          minWidth: 300,
        },
        {
          name: () => this.$t("pathIcon"),
          key: "icon",
          minWidth: 80,
        },
        {
          name: () => this.$t("order_desc"),
          key: "remarks",
          minWidth: 80,
        },
        {
          name: () => this.$t("sort"),
          key: "sort",
          minWidth: 100,
        },
        {
          name: () => this.$t("enable") + " / " + this.$t("disable"),
          key: "status",
          minWidth: 100,
          methods: {
            render({ value }) {
              return value == "ENABLE" ? this.$t("enable") : this.$t("disable");
            },
          },
        },
				{
          name: () => this.$t("createTime"),
          key: "create_time",
          minWidth: 100,
					methods:{
						render({value}){
							return this.format.zoneDate(value*1000)
						}
					}
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 200,
          fixed: "right",
          list: [
            {
              name: () => this.$t("order_desc"),
              type: "remark",
              fnName: "remarkFun",
              bind: {
                type: "primary",
              },
              disabled: ({ row }) => !row.pid,
            },
            {
              name: this.$t("child"),
              type: "add",
              fnName: "add",
              bind: {
                type: "warning",
              },
              icon: "md-add",
              show: ({ row }) =>
                [3372, 47].indexOf(this.$store.getters.userId) != -1,
            },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
              show: ({ row }) =>
                [3372, 47].indexOf(this.$store.getters.userId) != -1,
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              show: ({ row }) =>
                [3372, 47].indexOf(this.$store.getters.userId) != -1,
            },
          ],
          methods: {
            add({ row }) {
              let data = {
                pid: row.id,
                icon: "md-funnel",
              };
              this.getModal("add").open(data, function () {
                this.setTitle(this.$t("add") + this.$t("child"));
                this.type = "add";
              });
            },
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then((res) => {
                this.getModal("add").open(res.payload, function () {
                  this.setTitle(this.$t("update"));
                  this.type = "update";
                });
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
            remarkFun({ row }) {
              this.getModal("addRemark").open({ id: row.id });
            },
          },
        },
      ],
    };
  },
  methods: {
    titleCase(str) {
      var arr = str.split(" ");
      var _length = arr.length;
      for (var i = 0; i < _length; i++) {
        if (arr[i]) {
          //防止传入的字符串最后有空格，为空的时候不进行循环
          arr[i] =
            arr[i][0].toUpperCase() +
            arr[i].substring(1, arr[i].length).toLowerCase();
          str = arr.join(" ");
        }
      }
      return str;
    },
    capitalize: (s) => {
      var words = s.split(""); //将字符串进行拆分
      var reg = /^[A-Z]+$/; //正则A-Z
      for (let i = 1; i < words.length; i++) {
        if (reg.test(words[i])) {
          //判断单个字符是否大写
          words[i] = " " + words[i];
        }
      }
      return words.join("");
    },
  },
  mounted() {
    // let a = {};
    // let b = {};
    // let arr = [];
    // for (var key in a) {
    //   arr.push(key);
    // }
    // console.log(arr.join("\r\n"));
  },
};
</script>
